import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconInstagramSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="22" height="22" viewBox="0 0 22 22" fill="none"
             className={classNames(['svg-icon svg-instagram', className])}>
            <path
                d="M14.9987 0.333984H6.9987C3.31736 0.333984 0.332031 3.31932 0.332031 7.00065V15.0007C0.332031 18.682 3.31736 21.6673 6.9987 21.6673H14.9987C18.68 21.6673 21.6654 18.682 21.6654 15.0007V7.00065C21.6654 3.31932 18.68 0.333984 14.9987 0.333984ZM19.6654 15.0007C19.6654 17.574 17.572 19.6673 14.9987 19.6673H6.9987C4.42536 19.6673 2.33203 17.574 2.33203 15.0007V7.00065C2.33203 4.42732 4.42536 2.33398 6.9987 2.33398H14.9987C17.572 2.33398 19.6654 4.42732 19.6654 7.00065V15.0007Z"
                fill={color}/>
            <path
                d="M10.9974 5.66797C8.05206 5.66797 5.66406 8.05597 5.66406 11.0013C5.66406 13.9466 8.05206 16.3346 10.9974 16.3346C13.9427 16.3346 16.3307 13.9466 16.3307 11.0013C16.3307 8.05597 13.9427 5.66797 10.9974 5.66797ZM10.9974 14.3346C9.16006 14.3346 7.66406 12.8386 7.66406 11.0013C7.66406 9.16264 9.16006 7.66797 10.9974 7.66797C12.8347 7.66797 14.3307 9.16264 14.3307 11.0013C14.3307 12.8386 12.8347 14.3346 10.9974 14.3346Z"
                fill={color}/>
            <path
                d="M16.7302 5.97797C17.1227 5.97797 17.4409 5.6598 17.4409 5.26731C17.4409 4.87482 17.1227 4.55664 16.7302 4.55664C16.3377 4.55664 16.0195 4.87482 16.0195 5.26731C16.0195 5.6598 16.3377 5.97797 16.7302 5.97797Z"
                fill={color}/>
        </svg>

    );
};

IconInstagramSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconInstagramSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconInstagramSVG;